import { call, put, takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../../Utils/saga"
import Creators, { RequestsVerifiInformTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getRequestsVerifiInformActions: {
    request: Creators.getRequestsVerifiInformRequest,
    success: Creators.getRequestsVerifiInformSuccess,
    errors: Creators.requestsVerifiInformFailure
  },
  getRequestVerifiInformActions: {
    request: Creators.getRequestVerifiInformRequest,
    success: Creators.getRequestVerifiInformSuccess,
    errors: Creators.getRequestVerifiInformFailure
  },
  updateRequestVerifiInformStatusActions: {
    request: Creators.updateRequestVerifiInformStatusRequest,
    success: Creators.updateRequestVerifiInformStatusSuccess,
    errors: Creators.updateRequestVerifiInformStatusFailure
  }
}

const eventsOptions = {
  [constants.GET_REQUESTS_VERIFI_INFORM_REQUEST]: {
    api: services.getRequestsVerifiInform,
    actions: actions.getRequestsVerifiInformActions
  },
  [constants.GET_REQUEST_VERIFI_INFORM_REQUEST]: {
    api: services.getRequestVerifiInform,
    actions: actions.getRequestVerifiInformActions
  },
  [constants.UPDATE_REQUEST_VERIFI_INFORM_STATUS_REQUEST]: {
    api: services.updateRequestVerifiInformStatus,
    actions: actions.updateRequestVerifiInformStatusActions
  }
}

function* updateRequestVerifiInformStatus({ payload }) {
  const { onSuccess, onError, ...data } = payload
  try {
    const response = yield call(services.updateRequestVerifiInformStatus, {
      ...data
    })
    if (response?.ok) {
      yield put(
        Creators.updateRequestVerifiInformStatusSuccess({
          ...data,
          response
        })
      )
      onSuccess?.({
        ...data,
        response
      })
    } else {
      yield put(
        Creators.updateRequestVerifiInformStatusFailure({
          message: "Failed to update status"
        })
      )
      onError?.({ message: "Failed to update status" })
    }
  } catch (error) {
    yield put(
      Creators.updateRequestVerifiInformStatusFailure({
        message: "Failed to update status"
      })
    )
    onError?.({ message: "Failed to update status" })
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_VERIFI_INFORM_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUESTS_VERIFI_INFORM_REQUEST])
  )
  yield takeLatest(constants.GET_REQUEST_VERIFI_INFORM_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_REQUEST_VERIFI_INFORM_REQUEST])
  )
  yield takeLatest(
    constants.UPDATE_REQUEST_VERIFI_INFORM_STATUS_REQUEST,
    updateRequestVerifiInformStatus
  )
}
